(function($){

    $(window).on('load',function(){
        // Coming to bookmark from different page

        setTimeout(function(){
            var hash = window.location.hash;
        
            if ( hash == '' || hash == '#' || hash == undefined ) return false;

            var hash_target = $('[name=' + hash.slice(1) +']');
            var offset = 250;

            if($(window).width() < 1050) {
                offset = 190;
            }

            if(hash_target.hasClass('tab-link')) {
                hash_target.addClass('current').siblings().removeClass('current');
                var tab_id = hash_target.attr('data-tab');
                $('.tabs-top-content, .tabs-left-content').removeClass('current');
                $('#'+tab_id).addClass('current');
            }

            if(hash_target.hasClass('qabox-dt')) {
                hash_target.trigger('click');

                if($(window).width() < 769) {
                    hash_target = $('[name=' + hash.slice(1) + '].qabox-dt');
                }
            }
            
            if (hash_target.length) {
                $('html,body').stop().animate({
                    scrollTop: hash_target.offset().top - offset //offsets for fixed header
                }, 'ease-in');
            }
        }, 250);
    });
    
})(jQuery);
